// Flags and their explanations
const featureFlags = {
  // In use by stores/users/countries.
  BETTER_PICKUP: "Build better default pickup fields for 308 Crny Most",
  DISABLE_NEARBY: "Test disabling Nearby for US store 165.",
  // For checking translations.
  BLABLA_LANGUAGE:
    "Replaces translations with 'blabla'. Helps finding what's not translated.",
  GERMANY_ROLLOUT:
    "Germany rollout, hides Test buy, PQR and Shopping tool and poorly assembled type in product issue",
  REQUIRE_PROOF_OF_COMPLETION:
    "Require 'Proof of Completion' on Room Settings Tasks before being able to Complete the Task. Only use for those who requests it.",
  ENABLE_DISCOVER_NOW: "Show discover now on homepage",
  ENABLE_NOTIFICATIONS: "Enable notifications",
  ENABLE_TASK_MANAGEMENT: "Enables task management",
  ENABLE_NEW_PRODUCT_SEARCH: "Enable new product search",
  ENABLE_SMARTER_TESTBUYS: "Enable to use smarter testbuys and fetch from BQ",
  ENABLE_CUSTOM_TASK_V2: "Enable custom task v2",
  ENABLE_TESTBUY_REFACTOR:
    "Enable testbuy refactor used for testing, will be removed",
  ENABLE_TASK_MANAGEMENT_DEVELOPER: "Enables task management developer mode",
  ENABLE_PALLET_MULTIPACK_DATA_SERVICE:
    "Fetch pallet and multipack data from data service",
  ENABLE_PRODUCT_ISSUE_V2: "Enable product issue v2",
  ENABLE_ATKOMST:
    "Enable Åtkomst integration: unauthorized page, store switcher, and teams management Åtkomst stores",
  USE_NOTIFICATIONS_SERVICE:
    "Use the new dedicated notifications-service instead of core-service for notification calls",
  ENABLE_MULTIPLE_HFBS_FOR_TESTBUY:
    "Enable multiple HFB selection (up to 3) for test buy creation",
  ENABLE_MEDIA_V2_TASKS:
    "Enable media maintenance single and multiple media task types",
};

// Export object with the names of flags. Used by Fixa + Admin.
export const FLAGS = Object.keys(featureFlags).reduce(
  (all, key) => ({ ...all, [key]: key }),
  {} as Record<keyof typeof featureFlags, string>
);
